import React, { useState, useEffect } from 'react'
import { Navigate, Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import FormGroup from '@mui/material/FormGroup';
import FormControl from '@mui/material/FormControl';
import Alert from '@mui/material/Alert';
import Container from '@mui/material/Container';
import { login } from '../../actions/userActions'



function LoginPage() {
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    const [errorMessage, setErrorMessage] = useState('')
    const dispatch = useDispatch()
    const userLogin = useSelector((state) => state.userLogin)
    const { error, success } = userLogin

    useEffect(() => {
        console.log(userLogin, error, success)
    },
        []
    )

    useEffect(() => {
        if (error) {
            setErrorMessage(error)
        }
    },
        [error]
    )

    const submitHandler = (e) => {
        e.preventDefault()

        dispatch(login(username, password))
    }


    return (

        <>
        {/* {userLogin && userLogin.todoUserInfo &&
        <Navigate to="/profile" replace={true} />} */}
            {(success) && <Navigate to="/" replace={true} />}

            <Container maxWidth="sm">
                <Paper elevation={3} sx={{ p: 4, mt: 8 }}>
                    <IconButton
                        sx={{ p: 0 }}
                    >
                        <Avatar />
                    </IconButton>
                    <Typography component="h1" variant="h5">
                        Login
                    </Typography>


                    <FormControl
                        sx={{ minWidth: "20vw" }}
                    >
                        <FormGroup >
                            {errorMessage &&
                                <Alert variant="filled"
                                    size="small"
                                    sx={{ mb: 3, mt: 3 }}
                                    severity="error"
                                >{errorMessage}</Alert>}
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                id="username"
                                name="username"
                                label="username"
                                autoComplete="username"
                                autoFocus
                                onChange={(e) => { setUsername(e.target.value) }}
                            />
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                name="password"
                                label="password"
                                type="password"
                                id="password"
                                autoComplete="current-password"
                                onChange={(e) => setPassword(e.target.value)}
                            />

                            <Button
                                type="submit"
                                sx={{ mt: 3, mb: 3 }}
                                variant="contained"
                                color="primary"
                                name="submit"
                                onClick={submitHandler}
                            >
                                {"Submit"}
                            </Button>


                        </FormGroup>
                        <Stack direction="row"
                            sx={{
                                alignItems: "center",
                                justifyContent: "center",
                            }}>
                            <Typography>
                                {`Or `}
                                <Link to="/register">
                                    Sign Up
                                </Link>
                            </Typography>

                        </Stack>
                    </FormControl>
                </Paper>

            </Container >
        </>

    )
}

export default LoginPage
